import { Translatable } from '@app/types/translatable.type';

export const getSurveyResultsTitleTooltip = (numberOfResponses: number, totalOfParticipants: number): Translatable => {
    const translatable: Translatable = {
        key: 'surveys.tips.results.title',
        params: {
            numberOfResponses: numberOfResponses,
            totalOfParticipants: totalOfParticipants,
        },
    };

    return translatable;
};
